import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

import './interceptors/axios';

import { store } from './Redux/store';
import { Provider } from 'react-redux';

import { DarkModeProvider, useDarkMode } from './Components/CoreApp/context/DarkModeContext';
import ThemeProvider from './Components/CoreApp/theme/index';

import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

// Wrapper to read darkMode from context and pass as prop to ThemeProvider
function Main() {
  const { darkMode } = useDarkMode();

  return (
    <ThemeProvider darkMode={darkMode}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <DarkModeProvider>
        {/* Use Main so that useDarkMode hook works */}
        <Main />
      </DarkModeProvider>
    </Provider>
  </HelmetProvider>
);

serviceWorker.unregister();
reportWebVitals();
